import { createContext } from 'react-router';

type Profile = {
  role: string;
  client_id: string | null;
};

export const profileContext = createContext<Profile | null>(null);